<script>
import App from "@/pages/layouts/app.vue";
import Form from '@/pages/customer_products/_form.vue';
import StoreForm from "@wielink-application/shared/js/mixins/storeForm";

export default {
  mixins: [StoreForm],
  components: {App, Form},
  props: ['customer'],
  data() {
    return {
      formRoute: route('api.v1.customers.products.store', {'customer': this.customer}),
      redirectRoute: route('customers.products.index', {'customer': this.customer}),
      stayOnPageRedirect: route('customers.products.edit', {customer_product: '_id_', 'customer': this.customer}),
    }
  },
}
</script>

<template>
  <App title="Product koppelen">
    <form id="customerProductsForm" @submit.prevent="submit">
      <Form ref="form"/>
    </form>

    <template #bottomButtons>
      <FormButtons
          form-id="customerProductsForm"
          @backToOverview="stayOnPage = 0"
          :loading="loading"
          :cancel-route="redirectRoute"
      />
    </template>
  </App>
</template>